import { Component, Event, EventEmitter, h, Host, Listen, Prop, State } from '@stencil/core';
import { CardType } from '../interfaces/cards/card-type';
import { ProjectLabel } from '../interfaces/entities/project/project-label';
import { FilterProps } from '../interfaces/filter/filter-props';
import { StandardBlockProps } from '../interfaces/components/standard-block-props';

@Component({
	tag: 'dng-projects-overview',
})
export class ProjectsOverview {
	@Prop() allProjectsText: string;
	@Prop() withExternalProjects: boolean = false;
	@Prop() isLoggedIn: boolean = false;
	@Prop() cardType: CardType;

	//Filter Props
	@Prop() filterText: string;
	@Prop() resetFilterText: string;
	@Prop() showMoreThemes: string;
	@Prop() applyFilterText: string;
	@Prop() filterProps: FilterProps;
	@Prop() states: string;
	@Prop() preselectedMainFilterItems: string;
	@Prop() preselectedChipFilterItems: string;
	@Prop() withRegionFilter: boolean = false;
	@Prop() withCausesFilter: boolean = true;
	@Prop() withSkillsFilter: boolean = true;
	@Prop() withLocationFilter: boolean = true;
	@Prop() withHighlightedCards: boolean = false;
	@Prop() showResultsText: string;
	@Prop() highlightedHeading: string;
	@Prop() skillsText: string;
	@Prop() skillClusterSelectText: string;
	@Prop() withoutApplications: boolean = false;

	// No results block props
	@Prop() noResultsBlockProps: StandardBlockProps;
	@Prop() noResultsHeading: string;
	@Prop() noResultsBody: string;
	@Prop() createAccountText: string;
	@Prop() createAccountUrl: string;
	@Prop() showAllProjectsText: string;

	// Generic props
	@Prop() readMoreText: string;
	@Prop() toBeDeterminedText: string;
	@Prop() oneHourCallText: string;
	@Prop() projectsText: string;
	@Prop() forText: string;
	@Prop() recommendedProjectsPage: string;
	@Prop() resultsText: string;

	// Card labels
	@Prop() highlightedText: string;
	@Prop() urgentText: string;
	@Prop() externalText: string;
	@Prop() fulfilledText: string;
	@Prop() cardLabel: ProjectLabel;

	@Prop() withHiddenSubitems: boolean = true;

	@State() mobileSideBarIsOpen: boolean = false;

	@Event({ bubbles: true, composed: true })
	toggleSideBar: EventEmitter<boolean>;

	@Listen('toggleSideBar', { target: 'document' })
	toggleSideBarHandler(e: CustomEvent) {
		this.mobileSideBarIsOpen = e.detail;
	}

	componentWillLoad() {
		this.setProps();
	}

	setProps() {
		this.setFilterProps();
		this.setCardLabelProps();
		this.setNoResultsBlockProps();
	}

	setFilterProps() {
		this.filterProps = {
			filterText: this.filterText,
			resetFilterText: this.resetFilterText,
			showMoreThemes: this.showMoreThemes,
			applyFilterText: this.showResultsText,
			withHiddenSubitems: this.withHiddenSubitems,
			withRegionFilter: this.withRegionFilter,
			skillClusterSelectText: this.skillClusterSelectText,
			skillsText: this.skillsText,
			withSkillsFilter: this.withSkillsFilter,
			withLocationFilter: this.withLocationFilter,
			withCausesFilter: this.withCausesFilter,
			preselectedMainItems:
				this.preselectedMainFilterItems !== ''
					? this.preselectedMainFilterItems?.split(',').map(Number)
					: [],
		};
	}

	setNoResultsBlockProps() {
		this.noResultsBlockProps = {
			heading: this.noResultsHeading,
			body: this.noResultsBody,
			buttonPrimary: {
				name: this.createAccountText,
				url: this.createAccountUrl,
			},
			buttonSecondary: {
				name: this.showAllProjectsText,
			},
		};
	}

	setCardLabelProps() {
		this.cardLabel = {
			highlightedText: this.highlightedText,
			urgentText: this.urgentText,
			externalText: this.externalText,
			fulfilledText: this.fulfilledText,
		};
	}

	toggleMobileSideBar() {
		this.toggleSideBar.emit(!this.mobileSideBarIsOpen);
		this.mobileSideBarIsOpen = !this.mobileSideBarIsOpen;
	}

	render() {
		let content: HTMLElement;
		content = (
			<section class="grid">
				<section class="filter-bar sticky-top">
					<h2 class="heading--s no-margin--bottom">{this.allProjectsText}</h2>
					<dng-button
						buttonClass="btn--primary width--fit-content"
						buttonText={this.filterProps?.filterText}
						onClick={() => this.toggleMobileSideBar()}
					/>
				</section>
				<section class="projects-overview">
					<dng-side-bar
						filterProps={this.filterProps}
						fullScreenSideBar={true}
						sideBarScrollable={true}
					/>
					<dng-cards-overview
						card-type={
							this.cardType == CardType.JobboardProject
								? CardType.JobboardProject
								: CardType.Project
						}
						class="cards-overview__component"
						states={this.states}
						hasInfiniteScroll={true}
						withAccountPrompt={true}
						withExternalProjects={this.withExternalProjects}
						cardLabel={this.cardLabel}
						withHighlightedCards={this.withHighlightedCards}
						noResultsBlockProps={this.noResultsBlockProps}
						highlightedHeading={this.highlightedHeading}
						projectsText={this.projectsText}
						readMoreText={this.readMoreText}
						toBeDeterminedText={this.toBeDeterminedText}
						oneHourCallText={this.oneHourCallText}
						forText={this.forText}
						withoutApplications={this.withoutApplications}
						recommendedProjectsPage={this.recommendedProjectsPage}
						isLoggedIn={this.isLoggedIn}
						resultsText={this.resultsText}
					/>
				</section>
			</section>
		);

		return <Host>{content}</Host>;
	}
}
